import React, { useEffect, useState, Fragment } from 'react';
function getTimeUntilMidnight() {
  const now = new Date();
  const midnight = new Date(now);
  midnight.setHours(24, 0, 0, 0);
  const diff = midnight.getTime() - now.getTime();
  const totalSeconds = Math.max(0, Math.floor(diff / 1000));
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor(totalSeconds % 3600 / 60);
  const seconds = totalSeconds % 60;
  return {
    hours,
    minutes,
    seconds
  };
}
const pad = (n: number) => n.toString().padStart(2, '0');
export function CountdownTimer() {
  const [time, setTime] = useState(getTimeUntilMidnight());
  useEffect(() => {
    const interval = setInterval(() => {
      setTime(getTimeUntilMidnight());
    }, 1000);
    return () => clearInterval(interval);
  }, []);
  return <div className="flex flex-col items-center justify-center mb-5 bg-red-600 rounded-xl px-4 py-3 shadow-md" data-id="element-61">
      <span className="text-xs font-bold uppercase tracking-wider text-white mb-1.5" data-id="element-62">
        Oferta termina en:
      </span>
      <div className="flex items-center gap-1.5" data-id="element-63">
        {[{
        value: time.hours,
        label: 'Hs'
      }, {
        value: time.minutes,
        label: 'Min'
      }, {
        value: time.seconds,
        label: 'Seg'
      }].map((unit, idx) => <Fragment key={unit.label} data-id="element-64">
            <div className="flex flex-col items-center" data-id="element-65">
              <span className="bg-white text-red-600 font-black text-lg sm:text-xl tabular-nums px-2.5 py-1 rounded-md min-w-[2.5rem] text-center" data-id="element-66">
                {pad(unit.value)}
              </span>
              <span className="text-[10px] font-semibold text-white mt-0.5 uppercase" data-id="element-67">
                {unit.label}
              </span>
            </div>
            {idx < 2 && <span className="text-white font-black text-lg pb-3" data-id="element-68">:</span>}
          </Fragment>)}
      </div>
    </div>;
}